"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const object_hash_1 = __importDefault(require("object-hash"));
const caches = new Map();
function resourceCache(apiFn) {
  if (!caches.has(apiFn)) {
    caches.set(apiFn, new Map());
  }
  const apiCache = caches.get(apiFn);
  return {
    get() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      return apiCache.get(object_hash_1.default(params));
    },
    set(dataFn) {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      return apiCache.set(object_hash_1.default(params), dataFn);
    },
    delete() {
      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }
      return apiCache.delete(object_hash_1.default(params));
    },
    clear() {
      caches.delete(apiFn);
      return apiCache.clear();
    }
  };
}
exports.resourceCache = resourceCache;